export const NEWEST_WORDS_RETRIEVING = 'word.NEWEST_RETRIEVING';
export const NEWEST_WORDS_RETRIEVED = 'word.NEWEST_RETRIEVED';
export const MOST_TACKED_WORDS_RETRIEVING = 'word.MOST_TACKED_WORDS_RETRIEVING';
export const MOST_TACKED_WORDS_RETRIEVED = 'word.MOST_TACKED_WORDS_RETRIEVED';
export const TRENDING_RETRIEVAL_ERROR = 'word.RETRIEVAL_ERROR';



// WEBPACK FOOTER //
// ./src/stores/trends/action_types.js